
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Tip from 'component-tip'
import cn from 'classnames'
import './Tooltip.css'

class Tooltip extends Component {
  constructor (props) {
    super()
    this.tip = new Tip(props.message, {
      pad: 30,
      delay: 1
    })
    this.tip.effect('tip-fade')
  }

  render () {
    return (
      <span
        className={cn('Tooltip', {'Tooltip--underline': this.props.underline})}
        aria-label={this.props.message}
        ref={ref => (this.el = ref)}
      >
        {this.props.children}
      </span>
    )
  }

  componentDidMount () {
    this.tip.attach(this.el)
  }
}

Tooltip.displayName = 'Tooltip'

Tooltip.defaultProps = {
  underline: true
}

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  message: PropTypes.string.isRequired,
  underline: PropTypes.bool
}

export default Tooltip



// WEBPACK FOOTER //
// ./ui/Tooltip.js